import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import './index.scss';

import * as pageActions from '../../data/redux/page_details/actions';
import { ORIENTATION } from '../../data/config/constants';
import { IMG_LOGIN_BG } from '../../data/assets/img';
import { setTitleAsPath } from '../../data/config/utils';

function mapStateToProps(state) {
    return {
        page_details: state.page_details,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, pageActions), dispatch)
    };
}

class AuthContainer extends Component {
    componentDidMount() {
        setTitleAsPath();
    }

    componentDidUpdate() {
        setTitleAsPath();
    }

    render() {
        const { page_details, children } = this.props;
        const is_mobile = page_details.device_data.screen_width < 768;
        const screen_height = page_details.device_data.screen_height;
        const orientation = window.screen.width > window.screen.height ? ORIENTATION.LANDSCAPE : ORIENTATION.PORTRAIT;

        return (
            <div className={classNames("oriLoginContainer", { "ori-flex-row ori-full-min-height ori-flex-center": !is_mobile && orientation === ORIENTATION.LANDSCAPE })}>
                <div className={classNames("ori-box-shadow loginContentContainer", { "ori-flex-row loginContentLandscape": orientation === ORIENTATION.LANDSCAPE, "ori-flex-cr loginContentPortrait": orientation === ORIENTATION.PORTRAIT })}
                    style={{ minHeight: is_mobile && orientation === ORIENTATION.LANDSCAPE ? screen_height : "" }}>
                    <div className="ori-pad-15 ori-flex-column ori-flex-jc loginFormContainer">
                        {children}
                    </div>
                    <div className="ori-bg-primary-gradient loginImageContainer">
                        <img src={IMG_LOGIN_BG} alt="login image loading..." className="ori-animated ori-fade-in ori-img-contain" />
                    </div>
                </div>
            </div>
        );
    }
}

AuthContainer.propTypes = {
    page_details: PropTypes.object,
    admin_details: PropTypes.object,
    actions: PropTypes.object,
    history: PropTypes.object,
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(AuthContainer));


// WEBPACK FOOTER //
// ./src/app/authcontainer/index.js